module.exports = {"apiUrl":"https://wily-tomi-eag1ex-3730bf26.koyeb.app/payme-api","server":"REAL_SERVER","NODE_ENV":"production"};